import { NATIONALITY_OPTIONS } from './Step9/constants';

export const STEP_FIELDS = [
  ['language'],
  ['first_name', 'middle_name', 'last_name', 'gender', 'country', 'birthdate'],
  ['email', 'phone'],
  ['was_foreign'],
  ['address1', 'address2', 'zip', 'city', 'state'],
  ['profile_image'],
  ['id_image'],
  [
    'guardian_first_name',
    'guardian_last_name',
    'guardian_email',
    'guardian_phone',
    'emergency_contact_first_name',
    'emergency_contact_last_name',
    'emergency_contact_relation',
    'emergency_contact_phone',
  ],
  ['instagram', 'facebook', 'twitter'],
  ['ethnicity', 'nationality'],
  ['password'],
];

export const INITIAL_VALUES = {
  language: 'en',
  first_name: '',
  middle_name: '',
  last_name: '',
  gender: '',
  country: '',
  birthdate: '',
  email: '',
  phone: '',
  was_foreign: false,
  address1: '',
  address2: '',
  zip: '',
  city: '',
  state: '',
  profile_image: undefined,
  id_image: undefined,
  guardian_first_name: '',
  guardian_last_name: '',
  guardian_email: '',
  guardian_phone: '',
  emergency_contact_first_name: '',
  emergency_contact_last_name: '',
  emergency_contact_relation: '',
  emergency_contact_phone: '',
  instagram: '',
  facebook: '',
  twitter: '',
  ethnicity: NATIONALITY_OPTIONS[0].value,
  nationality: 'US',
  password: '',
  league: 'UPSL',
};

export const TRANSLATIONS: Record<string, Record<string, string>> = {
  en: {
    title_create_profile: 'Create a Player or Coach profile',
    title_player_reg_success: 'Almost done! Check your email to finish registration',

    subtitle_step_1: 'Personal information',
    subtitle_step_2: 'Contact information',
    subtitle_step_3: 'Have you been previously registered with a club outside of the US?',
    subtitle_step_4: 'Where do you live?',
    subtitle_step_5: 'Upload your profile photo',
    subtitle_step_6: 'Upload your Photo ID',
    subtitle_step_7: 'Parent/Guardian',
    subtitle_step_7_1: 'Emergency contact',
    subtitle_step_8: 'Social media',
    subtitle_step_9: 'Additional information',
    subtitle_step_10: 'Create a password',

    description_step_2: 'Use an email and phone number that is not associated with any other UPSL profile',
    description_step_3:
      'Select "Yes" if you have previously played or been registered with a club that is affiliated with a soccer federations outside of the U.S',
    description_step_4:
      'Provide your current address. This will be used to verify your identity and for shipping league credentials and other important information.',
    description_step_5:
      'The photo will be used on the UPSL website, gameday roster,  for any official league credentials.',
    description_step_6:
      'We require a government-issued ID to verify your identity. Failure to upload a proper and clear ID will result in a league suspension and possible fine',
    description_step_8:
      'Providing us your social media handles allows us to better promote you and your team. We want to showcase the best players and plays from around the league!',
    description_step_9: 'This helps us understand and reflect the diversity of our league.',

    label_language: 'Language for registration',
    label_first_name: 'First name',
    label_middle_name: 'Middle name',
    label_last_name: 'Last name',
    label_gender: 'Gender',
    label_place_of_birth: 'Place of Birth',
    label_date_of_birth: 'Date of Birth',
    label_email: 'Email',
    label_phone: 'Mobile Phone',
    label_address: 'Street Address',
    label_apartment: 'Apartment, suite, unit, building, floor',
    label_zip: 'Zip Code',
    label_city: 'City',
    label_state: 'State',
    label_profile_photo: 'Profile photo',
    label_photo_id: 'Photo ID',
    label_emergency_first_name: 'First Name',
    label_emergency_last_name: 'Last Name',
    label_emergency_contact_relation: 'Contact Relation',
    label_emergency_mobile_phone: 'Mobile Phone',
    label_ethnicity: 'Ethnicity',
    label_nationality: 'What nationality do you identify with?',
    label_password: 'Password',
    label_show_password: 'Show password',

    error_first_name: 'Enter first name',
    error_middle_name: 'Enter middle name',
    error_last_name: 'Enter last name',
    error_gender: 'Select gender',
    error_place_of_birth: 'Select place of birth',
    error_date_of_birth: 'Enter date',
    error_valid_date_of_birth: 'Enter valid date',
    error_min_8_years: 'Min age 8 years',
    error_email: 'Enter email',
    error_email_format: 'Invalid email format',
    error_phone: 'Enter phone',
    error_phone_format: 'Format: (123) 456-7890',
    error_address: 'Enter address',
    error_zip: 'Enter zip code',
    error_zip_5: '5 digits required',
    error_city: 'Select city',
    error_state: 'Select state',
    error_profile_photo: 'Upload profile photo',
    error_photo_id: 'Upload photo ID',
    error_instagram: 'Must be a valid Instagram link',
    error_facebook: 'Must be a valid Facebook link',
    error_twitter: 'Must be a valid X (Twitter) link',
    error_emergency_first_name: 'Enter first name',
    error_emergency_lase_name: 'Enter last name',
    error_ethnicity: 'Select ethnicity',
    error_nationality: 'Select nationality',
    error_password: 'Enter password',
    error_less_6_char: 'Less then 6 characters',
    error_no_uppercase_letter: 'No uppercase letter',
    error_no_numbers: 'No numbers',
    error_guardian_email: 'Guardian and player emails are equal',
    error_contact_relation: 'Select contact relation',

    button_back: 'Back',
    button_back_to_sign_in: 'Back to Sign in',
    button_next: 'Next',
    button_submit_application: 'Submit Application',
    button_create_profile: 'Create profile',

    test_steps: 'Steps',
    text_step_1_info:
      'For players and coaches only — if you’re a parent, please enter your child’s information here, not your own.',
    text_6_characters: 'At least 6 characters',
    text_includes_uppercase: 'Includes uppercase letter',
    text_includes_numbers: 'Includes number',
    text_clear_photo: 'Clear, forward-facing headshot photo of yourself',
    text_solid_bg: 'Solid background',
    text_image_size: 'Max 10MB, min 256×256px',
    text_image_format: 'Formats: .png, .jpg, .jpeg, .heic',
    text_image_document: "A legible image of a government-issued photo ID (e.g. driver's license, permit, passport)",
    text_image_max_10mb: 'Max 10MB',
    text_player_reg_success_1:
      'We’ve sent a confirmation email to the address you provided. Please open it and click the link to verify your UPSL profile.',
    text_player_reg_success_2: 'Once verified, you’ll be able to sign in and register with your team.',
  },
  es: {
    title_create_profile: 'Crea un perfil de Jugador o Entrenador',
    title_player_reg_success: '¡Casi terminas! Revisa tu correo para completar el registro',

    subtitle_step_1: 'Información personal',
    subtitle_step_2: 'Información de contacto',
    subtitle_step_3: '¿Has estado registrado previamente con un club fuera de EE.UU.?',
    subtitle_step_4: '¿Dónde vives?',
    subtitle_step_5: 'Sube tu foto de perfil',
    subtitle_step_6: 'Sube tu identificación con foto',
    subtitle_step_7: 'Padre/Tutor',
    subtitle_step_7_1: 'Contacto de emergencia',
    subtitle_step_8: 'Redes sociales',
    subtitle_step_9: 'Información adicional',
    subtitle_step_10: 'Crea una contraseña',

    description_step_2: 'Usa un correo y número de teléfono que no estén asociados con otro perfil de UPSL',
    description_step_3:
      'Seleccione "Sí" si anteriormente ha jugado o ha estado registrado en un club afiliado a una federación de fútbol fuera de los EE. UU.',
    description_step_4:
      'Proporciona tu dirección actual. Se usará para verificar tu identidad y para enviar credenciales y otra información importante de la liga.',
    description_step_5:
      'La foto se usará en el sitio web de UPSL, listas de juego y para credenciales oficiales de la liga.',
    description_step_6: 'Requerimos una identificación emitida por el gobierno para verificar tu identidad',
    description_step_8:
      'Proporcionar tus redes sociales nos permite promocionarte a ti y a tu equipo. ¡Queremos mostrar lo mejor de la liga!',
    description_step_9: 'Esto nos ayuda a entender y reflejar la diversidad de nuestra liga.',

    label_language: 'Idioma del registro',
    label_first_name: 'Nombre',
    label_middle_name: 'Segundo nombre',
    label_last_name: 'Apellido',
    label_gender: 'Género',
    label_place_of_birth: 'L. de nacimiento',
    label_date_of_birth: 'F. de nacimiento',
    label_email: 'Correo electrónico',
    label_phone: 'Teléfono',
    label_address: 'Dirección',
    label_apartment: 'Apartamento, unidad, edificio, piso',
    label_zip: 'Postal',
    label_city: 'Ciudad',
    label_state: 'Estado',
    label_profile_photo: 'Foto de perfil',
    label_photo_id: 'Identificación con foto',
    label_emergency_first_name: 'Nombre',
    label_emergency_last_name: 'Apellido',
    label_emergency_contact_relation: 'Relación del contacto',
    label_emergency_mobile_phone: 'Teléfono móvil',
    label_ethnicity: 'Etnia',
    label_nationality: '¿Con qué nacionalidad te identificas?',
    label_password: 'Contraseña',
    label_show_password: 'Mostrar contraseña',

    error_first_name: 'Ingresa el nombre',
    error_middle_name: 'Ingresa el segundo nombre',
    error_last_name: 'Ingresa el apellido',
    error_gender: 'Selecciona el género',
    error_place_of_birth: 'Selecciona el lugar de nacimiento',
    error_date_of_birth: 'Ingresa la fecha',
    error_valid_date_of_birth: 'Introduzca una fecha válida',
    error_min_8_years: 'Edad mínima 8 años',
    error_email: 'Ingresa el correo',
    error_email_format: 'Formato de correo inválido',
    error_phone: 'Ingresa el teléfono',
    error_phone_format: 'Formato: (123) 456-7890',
    error_address: 'Ingresa la dirección',
    error_zip: 'Ingresa el código postal',
    error_zip_5: 'Se requieren 5 dígitos',
    error_city: 'Selecciona la ciudad',
    error_state: 'Selecciona el estado',
    error_profile_photo: 'Sube una foto de perfil',
    error_photo_id: 'Sube una identificación con foto',
    error_instagram: 'Debe ser un enlace válido de Instagram',
    error_facebook: 'Debe ser un enlace válido de Facebook',
    error_twitter: 'Debe ser un enlace válido de X (Twitter)',
    error_emergency_first_name: 'Ingrese el nombre',
    error_emergency_lase_name: 'Ingrese el apellido',
    error_ethnicity: 'Selecciona la etnia',
    error_nationality: 'Selecciona la nacionalidad',
    error_password: 'Ingresa una contraseña',
    error_less_6_char: 'Menos de 6 caracteres',
    error_no_uppercase_letter: 'Sin letras mayúsculas',
    error_no_numbers: 'Sin números',
    error_guardian_email: 'Los correos electrónicos del tutor y del jugador son iguales',
    error_contact_relation: 'Seleccionar relación de contacto',

    button_back: 'Volver',
    button_back_to_sign_in: 'Volver a Iniciar sesión',
    button_next: 'Siguiente',
    button_submit_application: 'Enviar Solicitud',
    button_create_profile: 'Crear perfil',

    test_steps: 'Pasos',
    text_step_1_info:
      'Solo para jugadores y entrenadores. Si eres padre/madre, ingresa aquí la información de tu hijo, no la tuya.',
    text_6_characters: 'Mínimo 6 caracteres',
    text_includes_uppercase: 'Incluye una letra mayúscula',
    text_includes_numbers: 'Incluye un número',
    text_clear_photo: 'Foto clara y de frente de tu rostro',
    text_solid_bg: 'Fondo sólido',
    text_image_size: 'Máx. 10MB, mín. 256×256px',
    text_image_format: 'Formatos: .png, .jpg, .jpeg, .heic',
    text_image_document:
      'Una imagen legible de una identificación oficial con foto (por ejemplo: licencia, pasaporte, etc.)',
    text_image_max_10mb: 'Máximo 10MB',
    text_player_reg_success_1:
      'Hemos enviado un correo de confirmación a la dirección que proporcionaste. Ábrelo y haz clic en el enlace para verificar tu perfil de UPSL.',
    text_player_reg_success_2: 'Una vez verificado, podrás iniciar sesión y registrarte con tu equipo.',
  },
};
